import React from 'react';
import { TinyMceInputV2Type, TinyMCEInputV2 } from '@wajeez-web/components/ui';
import { FieldValues, UseControllerProps } from 'react-hook-form';

import { TinyMCEFormType } from '../Types';
import { FormInputController } from '../FormInputController';

export interface FormTinyMCEInputV2Props<TFormFields extends FieldValues>
  extends UseControllerProps<TFormFields>,
    TinyMceInputV2Type {
  fieldMeta: TinyMCEFormType;
  validationErrorMessages?: Partial<{
    required: string;
    pattern: string;
    minLength: string;
    maxLength: string;
  }>;
  readOnly?: boolean;
}

export const FormTinyMCEInputV2 = <TFormFields extends FieldValues>({
  name,
  fieldMeta,
  validationErrorMessages,
  readOnly,
  ...props
}: FormTinyMCEInputV2Props<TFormFields>) => {
  return (
    <FormInputController
      name={name}
      fieldMeta={fieldMeta}
      renderInput={({ ...controllerProps }) => (
        <TinyMCEInputV2
          label={fieldMeta.label}
          placeholder={fieldMeta.placeHolder}
          required={fieldMeta.required}
          {...controllerProps}
          {...props}
        />
      )}
      {...props}
    />
  );
};
